/*

   takes as input Object {nsw: object, mel: object, rvic: object etc}
   and flattens it, returning the key and one of the properties from its object

   Object {nsw: "sydney and surrounding areas", mel: "Melbourne", rvic: "Regional vic...."}

*/
export function generateKeyValue(fieldValues, fieldKey) {
  // var fieldValues = dictionary[fieldKey].fieldValues;
  
  var keyValues1 = Object.keys(fieldValues).reduce((r, k) => {
    r[k.trim()] = fieldValues[k].fieldValueLabel;
    return r;
  }, {})

  return keyValues1;
}

/* takes array of objects of the form
    {
       Campaign_Name: "",
       Campaign_Start_Month: "",
       Campaign_Start_Year: "",
       Region: "",
    }

    returns array of objects of the form

       {
         value: <<concatenation of the properties>>
         text: <<concatenation of the properties>>

       }



*/

export function generateCampaignNamesKeyValue(campaignNames) {
  var myArray = [];
  //var obj = {}

  for (var i = 0; i < campaignNames.length; i++) {
    var campaignName =
      campaignNames[i].Campaign_Owner +
      "_" +
      campaignNames[i].Campaign_Financial_Year;

    if (campaignNames[i].Campaign_Quarter) {
      campaignName += "_" + campaignNames[i].Campaign_Quarter;
    }

    // required field
    campaignName += "_" + campaignNames[i].Campaign_Region;

    if (campaignNames[i].Campaign_Brand) {
      campaignName += "_" + campaignNames[i].Campaign_Brand;
    }

    if (campaignNames[i].Campaign_Descriptor) {
      campaignName += "_" + campaignNames[i].Campaign_Descriptor;
    }

    //+ campaignNames[i].Campaign_QuartercampaignNames[i].Campaign_Region + "_" + campaignNames[i].Campaign_Descriptor;

    //   var campaignName = campaignNames[i].Campaign_Details;

    var obj = {
      value: campaignName,
      text: campaignName
    };

    myArray.push(obj);
  }

  return myArray;
}
